import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CalculatorIcon, HomeIcon, TrendingUpIcon } from 'lucide-react';
import { AgencyCommissionCalculator } from '../components/AgencyCommissionCalculator';
import { RentalCommissionCalculator } from '../components/RentalCommissionCalculator';
import { SaleCommissionCalculator } from '../components/SaleCommissionCalculator';
type CalculatorTab = 'agency' | 'rental' | 'sale';
export function CommissionCalculator() {
  const [activeTab, setActiveTab] = useState<CalculatorTab>('sale');
  const tabs = [{
    id: 'sale' as CalculatorTab,
    label: 'Tranzacții Vânzare',
    icon: TrendingUpIcon,
    color: 'from-[#FF6B35] to-[#e55a2b]'
  }, {
    id: 'rental' as CalculatorTab,
    label: 'Tranzacții Închiriere',
    icon: HomeIcon,
    color: 'from-[#21A366] to-[#1a8555]'
  }, {
    id: 'agency' as CalculatorTab,
    label: 'Încasări Agent',
    icon: CalculatorIcon,
    color: 'from-[#357BEB] to-[#2868d8]'
  }];
  return <div className="w-full min-h-screen bg-[#F1F1F1]" data-id="element-8059">
      <div className="bg-gradient-to-br from-[#132C53] to-[#1e4278] text-white py-12 sm:py-16 px-4" data-id="element-8060">
        <div className="max-w-7xl mx-auto text-center" data-id="element-8061">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4 px-4" data-id="element-8062">
            Calculatoare Comisioane
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto px-4" data-id="element-8063">
            Alege tipul de calculator pentru a calcula comisionul tău
          </motion.p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-8064">
        {/* Tabs */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-8065">
          {tabs.map(tab => {
          const Icon = tab.icon;
          return <motion.button key={tab.id} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => setActiveTab(tab.id)} className={`flex-1 flex items-center justify-center space-x-3 px-6 py-4 rounded-xl font-bold transition-all ${activeTab === tab.id ? `bg-gradient-to-r ${tab.color} text-white shadow-xl` : 'bg-white text-gray-700 hover:shadow-lg'}`} data-id="element-8066">
                <Icon className="w-5 h-5" data-id="element-8067" />
                <span data-id="element-8068">{tab.label}</span>
              </motion.button>;
        })}
        </div>

        {/* Calculator Content */}
        <motion.div key={activeTab} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} data-id="element-8069">
          {activeTab === 'agency' && <AgencyCommissionCalculator data-id="element-8070" />}
          {activeTab === 'rental' && <RentalCommissionCalculator data-id="element-8071" />}
          {activeTab === 'sale' && <SaleCommissionCalculator data-id="element-8072" />}
        </motion.div>
      </div>
    </div>;
}